import { Sort, SortOrder } from '@spike/model';

/** Page size for lists that still slice and sort in the browser. */
export const CLIENT_SIDE_APPOINTMENTS_PAGE_SIZE = 10000;

export const APPOINTMENTS_PAGE_SIZE = 10;

/** @deprecated Use APPOINTMENTS_PAGE_SIZE. */
export const GROOMING_PAGE_SIZE = APPOINTMENTS_PAGE_SIZE;

/** `sort_by` values accepted by the appointments list endpoints. */
export const appointmentSortColumns = {
    client: 'client',
    pet: 'pet',
    service: 'service',
    staff: 'staff',
    bookedAt: 'booked_at',
    total: 'total',
    room: 'room',
    status: 'status',
    transportationType: 'type',
    vehicle: 'vehicle',
    checkIn: 'check_in',
    checkOut: 'check_out',
    nights: 'nights'
} as const;

export const groomingSortColumns = appointmentSortColumns;

export const defaultAppointmentSort: Sort = {
    column: appointmentSortColumns.bookedAt,
    order: SortOrder.ASCENDANT
};

/** Client history opens on the most recent appointments. */
export const defaultClientHistorySort: Sort = {
    column: appointmentSortColumns.bookedAt,
    order: SortOrder.DESCENDANT
};

export const defaultGroomingSort = defaultAppointmentSort;

export const serverPaginatedListTypes = [
    'grooming',
    'daycare',
    'boarding',
    'evaluation',
    'transportation',
    'training',
    'walking',
    'requested',
    'all',
    'client'
] as const;

export const defaultServerSortForList = (listType: string): Sort =>
    listType === 'client' ? defaultClientHistorySort : defaultAppointmentSort;

export const isServerPaginatedList = (listType: string): boolean =>
    (serverPaginatedListTypes as ReadonlyArray<string>).includes(listType);
